import { ArrowBack } from '@mui/icons-material';
import './style.scss';
import { Box, IconButton, Typography } from '@mui/material';


interface IContentHeaderProps {
    title: string;
    subtitle?: string;
    wallpaper?: string;
    backTo?: () => void;
}

const ContentHeader: React.FunctionComponent<IContentHeaderProps> = ({
    title,
    subtitle = undefined,
    wallpaper = undefined,
    backTo = undefined
}) => {
    return <Box className='website-content-header' sx={{ backgroundImage: `url(${wallpaper ?? ''})` }}>
        {
            backTo !== undefined && <IconButton onClick={backTo} size='medium' className='website-content-header-backto'>
                <ArrowBack />
            </IconButton>
        }

        {
            subtitle && <Typography variant='subtitle2' className='website-content-header-subtitle'>
                {subtitle}
            </Typography>
        }

        <Typography variant='subtitle1' className='website-content-header-title'>
            {title}
        </Typography>
    </Box>;
}

export default ContentHeader;